import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit, isSubmitting } from 'redux-form';

import { Button, Loader } from 'components';
import { useIsMounted } from 'utils/hooks';

import './confirm-modal.scss';

export const ConfirmModalComponent = (props) => {
  const [isProceessing, setProcessing] = useState(false);
  const componentIsMounted = useIsMounted();

  const handleSubmit = () => {
    const {
      formSubmit,
      options: { form = {} },
    } = props;

    formSubmit(form.name);
  };

  const handleConfirm = async () => {
    const {
      hideModal,
      options: { onConfirm },
    } = props;

    setProcessing(true);

    const res = await onConfirm();

    if (componentIsMounted.current) {
      setProcessing(false);

      if (res === true) {
        hideModal();
      }
    }
  };

  const {
    options: { icon, title, text, form, confirmBtnText },
    hideModal,
    reduxFormState,
  } = props;

  const isFormSubmitting =
    form && isSubmitting(form.name)({ form: reduxFormState });

  return (
    <div className="white-box">
      <Loader isShow={isProceessing || isFormSubmitting}>
        <div className="confirm-modal">
          {icon}
          <div className="mt-7 fs-16 bold montserrat">{title}</div>
          <div className="mt-1 fs-12 lh-20 color-gray-dark">{text}</div>
          {form && (
            <form.component {...form.props} onSubmitSuccess={handleConfirm} />
          )}
          <div className="mt-10 flex justify-content-space-between">
            <Button
              testId="confirm-cancel"
              className="_simple-red"
              style={{ minWidth: '180px' }}
              onClick={hideModal}
            >
              Cancel
            </Button>
            <Button
              testId="confirm-submit"
              className="_red _right"
              style={{ minWidth: '180px' }}
              onClick={form ? handleSubmit : handleConfirm}
            >
              {confirmBtnText}
            </Button>
          </div>
        </div>
      </Loader>
    </div>
  );
};

ConfirmModalComponent.propTypes = {
  options: PropTypes.shape({
    icon: PropTypes.object,
    text: PropTypes.string,
    additionalContent: PropTypes.node,
    confirmBtnText: PropTypes.string,
    formSubmitting: PropTypes.bool,
    form: PropTypes.shape({
      name: PropTypes.string.isRequired,
      component: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        .isRequired,
      props: PropTypes.shape({
        onSubmit: PropTypes.func.isRequired,
      }),
    }),
  }),
  hideModal: PropTypes.func,
  onConfirm: PropTypes.func,
  formSubmit: PropTypes.func,
};

ConfirmModalComponent.defaultProps = {
  options: {},
  formSubmitting: false,
};

export const ConfirmModal = connect(({ form }) => ({ reduxFormState: form }), {
  formSubmit: submit,
})(ConfirmModalComponent);
